var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSeaLevelRise(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    fit: "",
    preserveAspectRatio: "xMidYMid meet",
    focusable: "false",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url('/?mapBounds=-151.6430826,-76.539079,208.0053549,81.0784081&mapStyle=Light&activeLocation=-31.4351977,24.1381674&activeLayers=GEOPORTAL_SHARED:Surge#clip0_16392_108660')"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.1 15c4.456 0 5.667 2.81 10.432 2.81 3.178 0 5.667-.687 7.468-2.06v3.75c-2.243 1.433-4.732 2.15-7.468 2.15-4.103 0-5.992-2.9-10.354-2.9-2.907 0-4.967.467-6.178 1.401v-3.75C1.096 15.467 3.13 15 6.1 15Zm0-6c4.456 0 5.898 2.805 10.432 2.805 3.024 0 5.513-.685 7.468-2.055v3.75c-2.243 1.436-4.732 2.154-7.468 2.154-4.103 0-5.749-2.904-10.354-2.904-3.07 0-5.13.467-6.178 1.401v-3.75C1.096 9.467 3.13 9 6.1 9Zm0-6c4.456 0 6.65 2.743 10.435 2.743 2.523 0 5.011-.665 7.465-1.993V7.5c-2.241 1.283-4.73 1.925-7.465 1.925-4.104 0-6.302-2.675-10.357-2.675-2.703 0-4.763.467-6.178 1.401v-3.75C1.096 3.467 3.13 3 6.1 3Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16392_108660"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeaLevelRise);
export default __webpack_public_path__ + "static/media/sea_level_rise.baa7b8bf546c60d977182e0ef0b3bf46.svg";
export { ForwardRef as ReactComponent };